<template>
  <svg aria-hidden="true" :width="width" :height="height" viewBox="-2 -1 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15.5" :stroke="color" />
    <path
      d="M16.0195 21.9102C18.6445 21.9102 20.3242 20.5664 20.3242 18.4102V18.4023C20.3242 16.7305 19.3555 15.7773 16.9883 15.2695L15.7617 14.9961C14.3008 14.6836 13.707 14.1367 13.707 13.3008V13.293C13.707 12.2305 14.6836 11.6133 16.0039 11.6133C17.3711 11.6055 18.2539 12.2773 18.4023 13.1992L18.418 13.3008H20.1133L20.1055 13.1914C19.9805 11.4414 18.418 10.0898 16.0273 10.0898C13.6367 10.0898 11.9492 11.4336 11.9414 13.3789V13.3867C11.9414 15.0508 12.9258 16.1133 15.2148 16.5977L16.4492 16.8633C17.9414 17.1836 18.5508 17.7461 18.5508 18.6133V18.6211C18.5508 19.668 17.5273 20.3867 16.0898 20.3867C14.582 20.3867 13.4961 19.7305 13.4023 18.707L13.3945 18.6211H11.6758L11.6836 18.7227C11.8398 20.6211 13.4727 21.9102 16.0195 21.9102Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DaySIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
